import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AbstractContentComponent } from '../abstract-content.component';
import { Context } from '@service/context.service';
import { Column } from '@shared/table/column';
import { ChopKatalog } from '@entity/chop';
import { AnwenderbetriebService } from '@service/anwenderbetrieb.service';
import { ActionButtonDirective } from '@shared/table/action-button.directive';
import { TableComponent } from '@shared/table/table.component';

@Component({
  selector: 'app-chop-kataloge',
  templateUrl: './chop-kataloge.component.html',
  styleUrls: ['./chop-kataloge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent, ActionButtonDirective],
})
export class ChopKatalogeComponent extends AbstractContentComponent implements OnInit {
  private anwenderbetriebService = inject(AnwenderbetriebService);

  kataloge: ChopKatalog[] = [];
  columns: Column[] = [];

  constructor() {
    super(Context.Anwenderbetrieb, 'CHOP_KATALOGE.TITLE');
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setColumns();
    this.reload();
  }

  protected onAnwenderbetriebIdChange(): void {
    this.reload();
  }

  protected onLanguageChange(): void {
    this.setColumns();
    this.markForCheck();
  }

  openDetail(katalog: ChopKatalog): void {
    this.navigate(['/chop-kataloge', katalog.id]);
  }

  private reload(): void {
    const abId = this.getAnwenderbetriebId();
    if (!abId) {
      this.kataloge = [];
      this.markForCheck();
      return;
    }
    this.startLoading();
    this.anwenderbetriebService.getChopKataloge(abId).subscribe((kataloge) => {
      this.kataloge = kataloge;
      this.loadingDone();
    });
  }

  private setColumns(): void {
    this.columns = [
      { field: 'jahr', headerKey: 'CHOP.JAHR', width: '120px', filterType: 'integer' },
      { field: 'bezeichnung.De', headerKey: 'GLOBAL.NAME_De', minWidth: '200px' },
      { field: 'bezeichnung.Fr', headerKey: 'GLOBAL.NAME_Fr', minWidth: '200px' },
    ];
  }
}
